import React from "react";
import PageTemplate from "components/templates/PageTemplate";
import Questions from "components/forms/Questions";

const data = [
  {
    title: "Ընդհանուր դրույթներ",
    subItems: [
      `Prognos-ը հարթակ է, որտեղ օգտատերերը կարող են գնահատել կանխատեսումները և դրանց հեղինակներին։`,
      `Օգտագործելով կայքը, դուք ընդունում եք այս պայմանները և պարտավորվում եք գործել համապատասխան օրինական ու էթիկական շրջանակներում։`,
      `Կայքի քաղաքականությունը կարող է փոփոխվել, ուստի խորհուրդ ենք տալիս պարբերաբար վերանայել այս բաժինը։`,
    ],
  },
  {
    title: "Օգտատիրոջ Պարտավորություններ",
    subItems: [
      `Օգտատերերը պարտավորվում են տրամադրել ճշգրիտ և արդիական տեղեկատվություն իրենց հաշվի ստեղծման կամ օգտագործման ժամանակ։`,
      `Կանխատեսումների գնահատման գործընթացում արգելվում է օգտագործել խաբուսիկ կամ մանիպուլյատիվ մեթոդներ։`,
      `Արգելվում է սպառնալ, վիրավորել կամ զրպարտել կանխատեսման հեղինակներին կամ այլ օգտատերերին։`,
    ],
  },
  {
    title: "Վարկանիշային Համակարգ",
    subItems: [
      `Prognos-ի վարկանիշային համակարգը ավտոմատ կերպով կարգավորում է կանխատեսումների հեղինակների գնահատականները՝ հիմնվելով դրանց ճշգրտության վրա։`,
      `Վարկանիշները ձևավորվում են օբյեկտիվ տվյալների հիման վրա, և որևէ միջամտություն կամ փոփոխություն առանց հիմնավոր պատճառի հնարավոր չէ։`,
      `Մանիպուլյացիայի կամ կեղծ վարկանիշային գործունեության հայտնաբերման դեպքում հաշիվը կարող է արգելափակվել։`,
    ],
  },
  {
    title: "Տվյալների Գաղտնիություն",
    subItems: [
      `Prognos-ը պարտավորվում է պաշտպանել օգտատերերի անձնական տվյալները և չփոխանցել դրանք երրորդ անձանց առանց իրավական հիմքի։`,
      `Օգտատերերի անձնական տվյալների օգտագործման մասին մանրամասների համար կարող եք այցելել մեր Գաղտնիության Քաղաքականություն էջը։`,
    ],
  },
  {
    title: "Կանխատեսումների Ճշգրտության Վերահսկում",
    subItems: [
      `Կայքը մշտապես հետևում է կանխատեսումների ճշգրտությանը՝ հիմնվելով իրական իրադարձությունների վրա։`,
      `Եթե կանխատեսումը սխալ է, դրա հեղինակին կարող են վերագրվել համապատասխան փոփոխություններ վարկանիշում։`,
    ],
  },
  {
    title: "Արգելված Գործողություններ",
    subItems: [
      `Մոլորեցնող կամ ապատեղեկատվություն տարածող գործողություններն արգելված են։`,
      `Ցանկացած սպառնալիք, ատելության խոսք, վիրավորական կամ ապօրինի բովանդակություն անընդունելի է։`,
      `Կայքի գործառույթները չարաշահելու կամ համակարգը խախտելու փորձերը կհանգեցնեն հաշվի արգելափակմանը։`,
    ],
  },
  {
    title: "Պատասխանատվության Սահմանափակում",
    subItems: [
      `Prognos-ը պատասխանատվություն չի կրում օգտատերերի կողմից հրապարակված գնահատականների կամ կարծիքների համար։`,
      `Կայքը չի երաշխավորում կանխատեսումների ճշգրտությունը, այլ միայն տրամադրում է վարկանիշային համակարգի միջոցով հաշվարկված գնահատականներ։`,
    ],
  },
  {
    title: "Պայմանների Փոփոխություն",
    subItems: [
      `Prognos-ը իրավունք ունի փոփոխելու այս պայմանները՝ առանց նախապես ծանուցելու։`,
      `Պայմանների ցանկացած փոփոխությունից հետո շարունակական օգտագործումը համարվում է համաձայնություն նոր պայմաններին։`,
    ],
  },
];

const TermsOfUse = () => {
  return (
    <div className="mb-[24px]">
      <PageTemplate
        title="Օգտագործման Պայմաններ"
        data={data}
        desc="Բարի գալուստ Prognos։ Նախքան մեր հարթակը օգտագործելը, խնդրում ենք ուշադիր կարդալ այս օգտագործման պայմանները։ 
Ձեր կայքի օգտագործումը նշանակում է, որ դուք համաձայն եք հետևյալ պայմաններին։"
      >
        <Questions />
      </PageTemplate>
    </div>
  );
};

export default TermsOfUse;
